import type { PocaConfig, Product } from "../types";
import { ProductCard } from "./ProductCard";

type Props = {
  products: Product[];
  config: PocaConfig;
  onNavigate?: (handle: string) => void;
};

export function ProductGrid({ products, config, onNavigate }: Props) {
  if (products.length === 0) {
    return null;
  }
  return (
    <div className="poca-grid">
      {products.map((p) => (
        <ProductCard key={p.id} product={p} config={config} onNavigate={onNavigate} />
      ))}
    </div>
  );
}
